const privateLiabilityFlows = {
  KEY_LOSS: 'key-loss',
  PERSON_DAMAGE: 'person-damage',
  ANIMAL_DAMAGE: 'animal-damage',
  LIABILITY: 'liability',
  BUSINESS: 'business',
};

export default privateLiabilityFlows;
